import { createAsyncThunk } from "@reduxjs/toolkit";
import supportService from "../../../api/services/support";

export const getAdminSessions = createAsyncThunk(
  "support/get-admin-sessions",
  async () => {
    return await supportService.getAdminSessions();
  }
);

export const getChatHistory = createAsyncThunk(
  "support/get-chat-history",
  async (chatId) => {
    return await supportService.getChatHistory(chatId);
  }
);

export const createChatSession = createAsyncThunk(
  "support/create-chat-session",
  async (sessionData) => {
    return await supportService.createChatSession(sessionData);
  }
);

export const sendMessage = createAsyncThunk(
  "support/send-message",
  async (messageData) => {
    return await supportService.sendMessage(messageData);
  }
);

export const closeChatSession = createAsyncThunk(
  "support/close-chat-session",
  async (chatId) => {
    return await supportService.closeChatSession(chatId);
  }
);

export const assignAgent = createAsyncThunk(
  "support/assign-agent",
  async ({ chatId, agentId }) => {
    return await supportService.assignAgent(chatId, agentId);
  }
);

export const getSupportAgents = createAsyncThunk(
  "support/get-support-agents",
  async () => {
    return await supportService.getSupportAgents();
  }
);

export const sendEmailFallback = createAsyncThunk(
  "support/send-email-fallback",
  async (messageData) => {
    return await supportService.sendEmailFallback(messageData);
  }
);

export const updateAgentStatus = createAsyncThunk(
  "support/update-agent-status",
  async (status) => {
    return await supportService.updateAgentStatus(status);
  }
);

export const getSupportStats = createAsyncThunk(
  "support/get-support-stats",
  async () => {
    return await supportService.getSupportStats();
  }
);

